module.exports = __webpack_public_path__ + "img/small-8.06ffb59c.webp";